import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Table from 'components/Layout/Table';
import Card from 'components/Layout/Card';
import SeachInput from 'components/form/SeachInput';
import { icons, limit } from 'utils/constants';
import './CallTracker.scss';
import moment from 'moment';
import PopOver from './PopOver';
import { getDataFromLocalStorage, objectToFormData } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { handleFetchCallData } from 'store/slices';
import { useNavigate } from 'react-router-dom';

const CallTracker = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [globalSearchVal, setGlobalSearchVal] = useState('');
  // const [abstractId, setAbstractId] = useState(null);
  // const [hoveredId, setHoveredId] = useState(null);
  const [timer, setTimer] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [cardData, setCardData] = useState({});

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    client_name: '',
  });

  const [searchPayload, setSearchPayload] = useState({
    resource_name: '',
    client_name: '',
    phone_no: '',
    status: '',
  });

  let userData = getDataFromLocalStorage();
  let { user_type } = userData;

  const { view: viewAccess } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Event Management'
    )?.sub_permission || {};

  const statusList = [
    { name: 'Welcome Message', value: 'Welcome Message' },
    { name: 'Completed', value: 'Completed' },
    { name: 'Missed', value: 'Missed' },
    { name: 'No Answer', value: 'No Answer' },
    { name: 'Ringing', value: 'Ringing' },
    { name: 'Cancelled', value: 'Cancelled' },
    { name: 'IVR', value: 'IVR' },
    { name: 'Voicemail', value: 'Voicemail' },
    { name: 'Rejected', value: 'Rejected' },
    { name: 'Failed', value: 'Failed' },
    { name: 'Machine Detected', value: 'Machine Detected' },
  ];

  const handleSearchChange = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getCallLogData(newData);
  };

  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getCallLogData(newData);
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearchVal(e.target.value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      let newData = { ...filterData, ...searchPayload };
      newData = { ...newData, client_name: e.target.value, offset: 0 };
      setIsLoading(true);
      setFilterData(newData);
      getCallLogData(newData);
    }, 800);
    setTimer(time);
  };

  const getCallLogData = async (obj) => {
    let resResultCount = 0;

    const response = await dispatch(handleFetchCallData(objectToFormData(obj)));
    if (response.status === 200) {
      resResultCount = response?.data?.result_count || 0;

      setTableList(response?.data?.callLogs);
      setCardData(response?.data);
      setFilterData({
        ...obj,
        total: resResultCount,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (['0', '1', '6'].includes(getDataFromLocalStorage('user_type'))) {
      getCallLogData({ ...filterData, ...searchPayload });
    } else {
      navigate('/');
    }
  }, []);

  const header = [
    ...(user_type !== '6'
      ? [
          {
            isSearch: true,
            searchInputName: 'resource_name',
            title: 'Resource',
          },
        ]
      : []),
    {
      isSearch: true,
      // isSearchDropdown: true,
      // dropdownOptions: {
      //   options: sourceList,
      //   key: 'client_name',
      //   value: 'client_name',
      // },
      searchInputName: 'client_name',
      title: <div className="text-nowrap ms-4 me-4">Client Name</div>,
    },
    { isSearch: true, searchInputName: 'phone_no', title: 'Contact' },
    { title: 'Last Call' },
    { title: 'Date' },
    {
      title: 'Status',
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: {
        options: statusList,
        key: 'name',
        value: 'value',
      },
      searchInputName: 'status',
    },
    // { title: 'Action' },
  ];

  const rowData = [];
  tableList?.forEach((elem, index) => {
    const {
      id,
      resource_name,
      client_name,
      contact,
      call_duration_time,
      date,
      callStatus,
    } = elem;

    let obj = [
      ...(user_type !== '6'
        ? [
            {
              value: <span>{resource_name ? resource_name : '-'}</span>,
            },
          ]
        : []),
      {
        value: (
          <div className="color-new-car text-nowrap">
            {client_name ? client_name : '-'}
          </div>
        ),
      },
      {
        value: <span>{contact ? contact : '-'}</span>,
      },
      {
        value: (
          <div
            style={{
              // width: '250px',
              wordBreak: 'break-word',
            }}
          >
            {call_duration_time ? call_duration_time : '-'}
          </div>
        ),
      },
      {
        value: moment(date).format('DD-MM-YYYY'),
      },
      {
        value: callStatus,
      },
      //History
      // {
      //   value: viewAccess === '1' && (
      //     <PopOver
      //       parentClass="op-drop-down"
      //       id="op-drop-down"
      //       text={
      //         <img
      //           src={
      //             hoveredId === elem?.id || abstractId === elem?.id
      //               ? icons.historyLightIcon
      //               : icons.historyDarkIcon
      //           }
      //           height={20}
      //           width={20}
      //           onMouseEnter={() => setHoveredId(elem?.id)}
      //           onMouseLeave={() => setHoveredId(null)}
      //         />
      //       }
      //       elem={elem}
      //       isOpen={abstractId === elem?.id}
      //       onToggle={(open) => setAbstractId(open ? elem?.id : null)}
      //       data={elem.history}
      //     />
      //   ),
      // },
    ];

    rowData.push({ data: obj });
  });

  const stats = [
    { title: 'Total Calls', value: cardData?.total_calls },
    { title: 'Connected Calls', value: cardData?.connected_calls },
    { title: 'Unanswered Calls', value: cardData?.unanswered_calls },
    { title: 'Total Duration', value: cardData?.total_duration },
    { title: 'Unique Clients', value: cardData?.unique_call },
  ];

  return (
    <div id="call-tracker-container">
      <div>
        <Row className="stats-container cms-2">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="cps-20">
                <h5 className="text-16-400 cpt-20">{stat.title}</h5>
                <div className="d-flex cpt-10 cpb-5">
                  <img src={icons.callIcon} height={24} width={24} alt="icon" />
                  <p className="text-20-400-25 cps-20">{stat.value}</p>
                </div>
              </div>
            </div>
          ))}
        </Row>

        <Card className="cps-10 cpe-10 cpb-20 cmt-20">
          <div className="d-flex justify-content-between align-items-center cpt-28 cpb-28 flex-wrap gap-2">
            <div className="d-flex ms-auto">
              <SeachInput
                placeholder="Search Name"
                id="client_name"
                value={globalSearchVal}
                onChange={handleGlobalSearch}
              />
            </div>
          </div>

          <Table
            isLoading={isLoading}
            header={header}
            rowData={rowData}
            maxHeight="60vh"
            filterData={filterData}
            searchInputChange={handleSearchChange}
            searchPayload={searchPayload}
            changeOffset={handelChangePagination}
            isOtherPagination
          />
        </Card>
      </div>
    </div>
  );
};

export default CallTracker;
